import { render, staticRenderFns } from "./dialogRoleInfo.vue?vue&type=template&id=946b036a&scoped=true&"
import script from "./dialogRoleInfo.vue?vue&type=script&lang=js&"
export * from "./dialogRoleInfo.vue?vue&type=script&lang=js&"
import style0 from "./dialogRoleInfo.vue?vue&type=style&index=0&id=946b036a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "946b036a",
  null
  
)

export default component.exports